module.exports = __webpack_public_path__ + "img/checkmark-circle.48f86c98.svg";